import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DevisStatut, IDevisResponse } from 'src/app/shared/models/devis';
import { DevisHistoryComponent } from './devis-history/devis-history.component';

@Component({
  selector: 'app-devis-view-dialog',
  templateUrl: './devis-view-dialog.component.html',
  styleUrls: ['./devis-view-dialog.component.less']
})
export class DevisViewDialogComponent {

  readonly DevisStatut = DevisStatut;

  constructor(
    public dialogRef: MatDialogRef<DevisViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDevisResponse,
    private dialog: MatDialog
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  openHistory(): void {
    this.dialog.open(DevisHistoryComponent, {
      data: {
        devisId:        this.data.devisId,
        devisReference: this.data.devisReference
      },
      width:       '800px',
      maxWidth:    '95vw',
      panelClass:  'history-dialog-panel',
      autoFocus:   false
    });
  }

  get statClass(): string {
    switch (this.data.devisStatut) {
      case DevisStatut.CREE:        return 'statut-cree';
      case DevisStatut.EN_ATTENTE:  return 'statut-en-attente';
      case DevisStatut.ACCEPTE:     return 'statut-accepte';
      case DevisStatut.REFUSE:      return 'statut-refuse';
      case DevisStatut.ARCHIVE:     return 'statut-archive';
      default:                      return '';
    }
  }
}